<template>

  <v-container
  fluid
  fill-width
   style="overflow: visible !important;"
  >
    
    <v-data-table
        :headers="headers"
        :items="users"
        class="elevation-3"
        item-key="email"
        :loading="isLoading"
        :pagination.sync="pagination"
        style="overflow: visible !important;"
    >
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template v-slot:items="props" style="overflow: visible !important;">
        <td >{{ props.item.email }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.email_verified }}</td>
        <td><v-select
          :items="groups"
          item-text="GroupName"
          item-value="GroupName"
					v-model="props.item.groups"
					dense
          chips
          attach
          multiple
					v-on:input="groupChange(props.item)"
        ></v-select></td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
	import http from "../http";
	import { baseApiUrl } from "../config";

  export default {
    name: 'Users',
    data() {
      return {
        headers: [
          { text: 'Email', value: 'email' },
          { text: 'Name', value: 'name' },
          { text: 'Verified', value: 'email_verified' },
          { text: 'Group', value: 'group' },

				],
				isLoading: false,
				users: [],
				groups: [], // ['MDSi-User', 'Cisco-User'],
        filter: 'All',
        search: '',
        pagination: {
          rowsPerPage: 25,
        },
      };
    },
    components: {
    },
    async mounted() {
      await Promise.all([
        this.loadUsers(),
        this.loadAllGroups()
      ]);

      this.$store.commit('SET_BREADCRUMBS', [
        { text: 'Administration', disabled: true },
        { text: 'Users', disabled: true },
      ]);
    },
    methods: {
      async groupChange(user) {
				console.log('Changing user:', user.email, 'to group', user.group);

        await http.post(`${baseApiUrl}/admin/change-group`, { Username: user.Username, groups: user.groups });
			},
      async loadUsers() {
        this.isLoading = true;
        const usersResponse = await http.get(`${baseApiUrl}/admin/users`);
        console.log('usersResponse:', usersResponse);
        this.users = usersResponse.data;
        this.isLoading = false;
      },
      async loadAllGroups() {
        this.isLoading = true;
        const groupsResponse = await http.get(`${baseApiUrl}/admin/groups`);
        
        if (groupsResponse && groupsResponse.data) {
          this.groups = groupsResponse.data.map(g => g.GroupName);
        }

        console.log('groupsResponse:', groupsResponse);
        console.log('this.groups:', this.groups);
        this.isLoading = false;
      }
    },
    async beforeCreate() {
    },
    async beforeUpdate() {
    },
  };
</script>

<style>
  .v-table__overflow {
    overflow: visible !important;
  }
</style>
